import React, { useContext, useEffect } from "react";
import { OperationContext } from "../CreateOperation";
import { useSearchParams } from "react-router";
import { OperationConstant } from "../../../core/_constant";
import { TitleBadge } from "../components/TitleBadge";
import { DatePicker, Empty, Radio } from "antd";
import { DebarkmentTimesheet } from "./debarkment/DebarkmentTimesheet";
import { EmbarkmentTimesheet } from "./embarkment/EmbarkmentTimesheet";
import { FormatDate } from "../../../../../utilities/formatDate";
import dayjs from "dayjs";

export const TimesheetOperations = () => {
  const { initialValue, filter, setFilter } = useContext(OperationContext);

  const [searchParams, setSearchParams] = useSearchParams();

  const typeFromURL = parseInt(searchParams.get("movment") || "");

  const ALL_TYPE = [
    initialValue?.debarkationMovement?.id && {
      label: OperationConstant.LANDING_LABEL,
      value: initialValue?.debarkationMovement?.id,
      component: <DebarkmentTimesheet />,
    },
    ,
    initialValue?.embarkationMovement?.id && {
      label: OperationConstant.BOARDING_LABEL,
      value: initialValue?.embarkationMovement?.id,
      component: <EmbarkmentTimesheet />,
    },
  ]?.filter((item) => item);

  useEffect(() => {
    const currentMovement = searchParams.get("movment")
    if (!currentMovement || currentMovement === "undefined") {
      const newParams = new URLSearchParams(searchParams);
      newParams.set("movment", ALL_TYPE[0]?.value.toString());
      setSearchParams(newParams);
    }
    /* setFilter((prev: any) => ({
      ...prev,
      teamsCreatedAt: dayjs().format("YYYY-MM-DD"),
    })); */
  }, [initialValue]);

  useEffect(() => {
    if (searchParams.has("movement")) {
      setFilter((prev: any) => ({
        ...prev,
        teamsCreatedAt: dayjs().format("YYYY-MM-DD"),
      }));
    }
  }, [initialValue]);

  const handleChangeType = (value: number) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set("movment", value?.toString());
    let reachedType = false;
    const keysToDelete: string[] = [];

    newParams.forEach((_, key) => {
      if (reachedType) {
        keysToDelete.push(key);
      }
      if (key === "movment") {
        reachedType = true;
      }
    });

    keysToDelete.forEach((key) => newParams.delete(key));

    setSearchParams(newParams);
  };

  const activeComponent =
    ALL_TYPE.find((item) => item?.value === typeFromURL)?.component ||
    ALL_TYPE[0]?.component;

  const handleDateFilter = (value: any) => {
    if (value) {
      setFilter((prev: any) => ({
        ...prev,
        teamsCreatedAt: dayjs(value).format("YYYY-MM-DD"),
      }));
    } else {
      setFilter((prev: any) => ({
        ...prev,
        teamsCreatedAt: dayjs().format("YYYY-MM-DD"),
      }));
    }
  };

  return (
    <>
    {
      typeFromURL ? (
        <div className="">
      <div className="d-flex flex-wrap gap-2 mb-4">
        <TitleBadge
          label="Référence du voyage"
          value={initialValue?.travelReference}
        />
        <TitleBadge
          label="Opération"
          value={initialValue?.operationType?.label}
        />
        {/* <TitleBadge label="Equipe Cabotage" value={initialValue?.customer?.label} /> */}
        <TitleBadge label="Client" value={initialValue?.customer?.label} />
        {/* <TitleBadge
          label="TDM"
          value={initialValue?.myTeamHandlingTechnicians}
        /> */}
        <TitleBadge label="Navire" value={initialValue?.ship} />
        {initialValue?.estimatedArrivalAt && (
          <TitleBadge
            label="Date d'arrivée prévue"
            value={FormatDate.formatDateToDisplay(
              initialValue?.estimatedArrivalAt
            )}
          />
        )}
        {/* <TitleBadge
          label=""
          value={initialValue?.myTeamHandlingTechnicians}
        /> */}
      </div>
      <div className="title_wrapper">
        <div className="d-flex gap-2 align-items-center justify-content-center">
          <label
            htmlFor=""
            style={{
              // fontWeight: "bolder",
              fontWeight: "600",
              color: "gray",
              paddingLeft: "2px",
            }}
          >
            {" "}
            Date{" "}
          </label>
          <DatePicker
            placeholder=""
            value={dayjs(filter.teamsCreatedAt, "YYYY-MM-DD")}
            format={"DD/MM/YYYY"}
            onChange={handleDateFilter}
            // size="large"
          />
        </div>
      </div>
      <div className="">
        <Radio.Group
          onChange={(e) => handleChangeType(e.target.value)}
          value={typeFromURL}
          optionType="button"
          buttonStyle="solid"
        >
          {ALL_TYPE?.map((item: any) => (
            <Radio value={item?.value}>{item?.label}</Radio>
          ))}
        </Radio.Group>
      </div>
      <div className="">{activeComponent}</div>
    </div>
      ) : (
        <Empty description="En attente de manifeste"/>
      )
    }
    </>
  );
};
